'use client'
import type { FC } from 'react'
import type { StorefrontWidget, WidgetBlog } from 'ecosystem'
import { VStack } from '@chakra-ui/react'
import { Hero } from 'ui'
import { BlogContent, BlogInfo } from '../components'
import { type WidgetImplementation } from '../../widgets/registry/typings'

type WidgetBlogPostType = WidgetImplementation<StorefrontWidget<WidgetBlog>>

const WidgetBlogPost: FC<WidgetBlogPostType> = ({ widgetId, widget }) => {
  return (
    <VStack id={widgetId} w="full">
      <Hero
        content={{
          title: widget.widget.title
        }}
        imgUrl={widget.widget.imgUrl}
        priority
      />
      <BlogInfo blogPost={widget.widget} />
      <BlogContent blogPost={widget.widget} />
    </VStack>
  )
}

export default WidgetBlogPost
